import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';
import { useUntypedTranslation } from '../../hooks/useUntypedTranslation';

const Footer: React.FC = () => {
  // Use our untyped translation hook to bypass TypeScript errors
  const { t } = useUntypedTranslation();
  
  const currentYear = new Date().toLocaleString('en-US', {
    timeZone: 'Europe/Berlin',
    year: 'numeric',
  });
  
  return (
    <Box
      component="footer"
      sx={theme => ({
        backgroundColor: theme.colors.bone, // Uses the 'bone' color from the theme
        paddingY: { xs: 0.5, sm: 2 }, // Reduced vertical padding for mobile
        paddingX: { xs: 1.5, sm: 4 },
        marginTop: 'auto',
      })}
    >
      <Container
        maxWidth={false}
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: { xs: 'center', sm: 'space-between' }, // Space between items on desktop
          alignItems: 'center', // Center items vertically
          gap: { xs: 1, sm: 0 }, // Gap between items
        }}
      >
        {/* "All rights reserved" Text */}
        <Typography
          color="text.primary"
          sx={{
            fontSize: { xs: '0.6rem', sm: '1rem' }, // Reduced font size for mobile
            textAlign: { xs: 'center', sm: 'left' }, // Centered on mobile, left-aligned on desktop
            marginTop: { xs: 0.5, sm: 0 }, // Reduced top margin for mobile
            width: { xs: '100%', sm: 'auto' }, // Full width on mobile for better centering
          }}
        >
          {t('footer.copyright')}
        </Typography>

        {/* Navigation Links */}
        <Box
          component="nav"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            gap: { xs: 1, sm: 4 }, // Gap between links
            justifyContent: { xs: 'center', sm: 'flex-end' }, // Center on mobile, right-aligned on desktop
            width: { xs: '100%', sm: 'auto' }, // Full width on mobile for better centering
          }}
        >
          <Link
            href="/terms"
            aria-label="Navigate to Terms page"
            sx={theme => ({
              color: theme.palette.text.primary,
              textDecoration: 'none',
              fontWeight: 500,
              transition: 'opacity 0.3s ease',
              '&:hover': {
                opacity: 0.8,
              },
              fontSize: { xs: '0.75rem', sm: '1rem' }, // Reduced link font size for mobile
            })}
          >
            {t('footer.terms')}
          </Link>
          <Link
            href="/privacy"
            aria-label="Navigate to Privacy page"
            sx={theme => ({
              color: theme.palette.text.primary,
              textDecoration: 'none',
              fontWeight: 500,
              transition: 'opacity 0.3s ease',
              '&:hover': {
                opacity: 0.8,
              },
              fontSize: { xs: '0.75rem', sm: '1rem' }, // Reduced link font size for mobile
            })}
          >
            {t('footer.privacy')}
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
